import React from 'react'
import { Card, Placeholder } from 'semantic-ui-react'

const BookingCardSkeleton = () => {
  return (
    <Card fluid centered>
      <Card.Content>
        <Placeholder>
          <Placeholder.Header image>
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Header>
          <Placeholder.Paragraph>
            <Placeholder.Line length='short' />
            <Placeholder.Line length='medium' />
            <Placeholder.Line length='medium' />
          </Placeholder.Paragraph>
          <Placeholder.Paragraph>
            <Placeholder.Line length='short' />
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Paragraph>
          <Placeholder.Paragraph>
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Paragraph>
        </Placeholder>
      </Card.Content>
    </Card>
  )
}

export default BookingCardSkeleton